var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"fdScroll",staticClass:"d-flex flex-grow-1 mh-0 flex-column"},[_c('div',{staticClass:"d-flex flex-grow-1 flex-column"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }